/* istanbul ignore file */
import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import { Tooltip } from 'framework/ui/mui-builder';
import { AddressInput } from 'framework/form';
import {
  MaritalStatusInput,
  ChildrenInput,
  FamilyMemberListInput,
  FamilyMemberInput,
  EducationListInput,
} from 'domain/shared/employee';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';

const HOME_ADDRESS_TOOLTIP = 'Residential address';

interface EF1FormProps {
  isNotPolishOffice: any;
}

const EF1Form = ({ isNotPolishOffice }: EF1FormProps) => (
  <>
    <FormSection title="Contact information">
      <Typography variant="h3" mb={1.25}>
        Home address
        <Tooltip title={HOME_ADDRESS_TOOLTIP} placement="right" id="address-tooltip">
          <InfoIcon id="address-tooltip" />
        </Tooltip>
      </Typography>
      <AddressInput hasAddressLine2 source="homeAddress" />
    </FormSection>

    <FormSection title="Family">
      <FormRow>
        <MaritalStatusInput source="maritalStatus" />
      </FormRow>
      <BigFormRow>
        <Typography variant="body1" mb={1}>
          Please provide information about close relatives (i.e. parents, spouse) below:
        </Typography>
        <FamilyMemberListInput source="familyMembers" inputTemplate={FamilyMemberInput} addText="Add family member" />
      </BigFormRow>
      <BigFormRow>
        <ChildrenInput source="familyChildren" />
      </BigFormRow>
    </FormSection>

    <FormSection title="Education">
      <EducationListInput source="educations" inputProps={{ isAdditionalInfoVisible: false }} />
    </FormSection>
  </>
);

export default EF1Form;
